'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = SelectBox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _SelectBoxCustom = require('./SelectBoxCustom/SelectBoxCustom');

var _SelectBoxNative = require('./SelectBoxNative/SelectBoxNative');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

(0, _reactackleCore.registerDefaultComponentTheme)('selectBox', _theme2.default);

var propTypes = _extends({}, _SelectBoxNative.SelectBoxNative.propTypes, _SelectBoxCustom.SelectBoxCustom.propTypes, {
  /**
   * Type of the SelectBox
   */
  type: _propTypes2.default.oneOf(['custom', 'native'])
});

var defaultProps = _extends({}, _SelectBoxNative.SelectBoxNative.defaultProps, _SelectBoxCustom.SelectBoxCustom.defaultProps, {
  type: 'custom'
});

function SelectBox(props) {
  var Select = props.type === 'custom' ? _SelectBoxCustom.SelectBoxCustom : _SelectBoxNative.SelectBoxNative;
  return _react2.default.createElement(Select, props);
}

SelectBox.propTypes = propTypes;
SelectBox.defaultProps = defaultProps;
SelectBox.displayName = 'SelectBox';